import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { TrackingService2, TrackingService2Symbol, createQuery } from '@/app/tracking/api';
import * as SectionTrackingApi from './tracking/api'
import { SectionStateStoreModule, SectionStateStoreModuleSymbol } from './section-state-store-module';
import { SectionStatus } from './section-state'

const debug = Debug('load-section-state-command');

@injectable()
export class QuerySectionStatesCommand {

  constructor(
    @inject(TrackingService2Symbol)
    private trackingService: TrackingService2,
    @inject(SectionStateStoreModuleSymbol)
    private store: SectionStateStoreModule) {
  }

  public async execute() {

    debug('executing QuerySectionStateCommand');

    this.store.startLoading();

    const query = createQuery<SectionTrackingApi.QuerySectionStatesTrackingQuery>('query-section-states', {})
    const result = await this.trackingService.query(query)
    debug('section states loaded', result);
    this.store.finishLoading(result.sections.map((x) => ({
      id: x.id,
      status: this.mapPhase(x.details.status),
      durationSeconds: x.details.durationSeconds
    })));
  }

  private mapPhase(status: SectionTrackingApi.SectionStatus): SectionStatus {
    switch (status) {
      case SectionTrackingApi.SectionStatus.notAttempted:
        return 'not-attempted';
      case SectionTrackingApi.SectionStatus.incomplete:
        return 'incomplete';
      case SectionTrackingApi.SectionStatus.completed:
        return 'completed';
    }
  }
}
